module.exports = __webpack_public_path__ + "static/media/out-right-front.6e46565c.png";